module.exports = __webpack_public_path__ + "static/media/new_logo.56e696b0.png";